import { render, staticRenderFns } from "./BinaryQuestion.vue?vue&type=template&id=c5af7926&scoped=true"
import script from "./BinaryQuestion.vue?vue&type=script&lang=js"
export * from "./BinaryQuestion.vue?vue&type=script&lang=js"
import style0 from "./BinaryQuestion.vue?vue&type=style&index=0&id=c5af7926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5af7926",
  null
  
)

export default component.exports